import { useState } from 'react'
import { StartTrialModal } from './StartTrialModal'

// Internal admins (Rolla staff managing a team on the customer's behalf — see useIsInternalAdmin)
// aren't forced into StartTrialModal like a regular admin on a no-plan team would be, but they
// should still see that the team hasn't started a trial, since that's real account state. See
// Layout.tsx for the gating logic that decides which of these two renders.
export function NoTrialBanner() {
  const [showPreview, setShowPreview] = useState(false)

  return (
    <>
      <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 bg-yellow-50 px-3 py-2 text-center text-sm text-yellow-800">
        <button
          onClick={() => setShowPreview(true)}
          className="mr-1 rounded border border-yellow-300 bg-white px-2 py-0.5 text-xs font-medium text-yellow-800 hover:bg-yellow-100"
        >
          Click to see Start Trial Modal
        </button>
        <span className="font-semibold">This account hasn&apos;t started a trial or subscription.</span>
        <span>You&apos;re seeing this because you&apos;re an internal admin on this team.</span>
      </div>
      {showPreview && <StartTrialModal previewOnly onClose={() => setShowPreview(false)} />}
    </>
  )
}
